const cardsData = [
  {
    title: '蜜桃校园 · 心跳加速的青春物语',
    tag: '校园恋爱',
    desc: '羞涩告白、天台邂逅、学园祭的心跳瞬间——蜜桃动漫在线校园系列全收录，羞羞动漫在线高清播放纯爱经典一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20school%20campus%20scene%20with%20cherry%20blossoms%2C%20two%20anime%20characters%20in%20school%20uniforms%20sharing%20a%20gentle%20moment%2C%20soft%20peach%20and%20pink%20color%20palette%2C%20warm%20sunset%20lighting%2C%20dreamy%20atmosphere%2C%20romantic%20anime%20visual%20style%2C%20clean%20composition%20with%20soft%20focus&width=800&height=560&seq=card-01-school&orientation=landscape',
  },
  {
    title: '奇幻异世界 · 冒险与邂逅的旅程',
    tag: '奇幻冒险',
    desc: '从现代穿越到魔法大陆，羞羞动漫在线观看完整版异世界系列每日更新，蜜桃动漫在线奇幻专题热血与温情兼具。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20fantasy%20world%20with%20floating%20islands%20and%20magical%20glowing%20crystals%2C%20beautiful%20female%20adventurer%20character%20with%20flowing%20hair%2C%20warm%20golden%20and%20peach%20color%20scheme%2C%20soft%20ethereal%20lighting%2C%20detailed%20background%20with%20castles%2C%20anime%20art%20style&width=800&height=560&seq=card-02-fantasy&orientation=landscape',
  },
  {
    title: '新番速递 · 48小时同步日区更新',
    tag: '新番热映',
    desc: '最新蜜桃动漫在线新番第一时间上线本站，羞羞动漫在线新番追更不落人后，每周更新清单准时推送，精彩不容错过。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20modern%20room%20with%20large%20screen%20displaying%20anime%20characters%2C%20cozy%20viewing%20setup%2C%20warm%20ambient%20lighting%2C%20peach%20and%20coral%20color%20tones%2C%20chill%20atmosphere%2C%20anime%20merchandise%20decorations%2C%20soft%20and%20inviting%20composition&width=800&height=560&seq=card-03-new&orientation=landscape',
  },
  {
    title: '经典重温 · 高分蜜桃动漫在线合集',
    tag: '经典回顾',
    desc: '那些年追过的蜜桃动漫在线经典全收录，羞羞动漫在线观看完整版高分作品一集不落，重温最初的感动与心跳回忆。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20nostalgic%20vintage%20anime%20aesthetic%2C%20beautiful%20female%20character%20in%20retro%20anime%20art%20style%2C%20soft%20film%20grain%20effect%2C%20warm%20sepia%20and%20peach%20tones%2C%20romantic%20and%20nostalgic%20mood%2C%20cherry%20blossom%20petals%2C%20classic%20anime%20composition&width=800&height=560&seq=card-04-classic&orientation=landscape',
  },
  {
    title: '独家策划 · 蜜桃动漫在线主题月',
    tag: '独家专题',
    desc: '每月精心策划蜜桃动漫在线专题，按主题深度整理羞羞动漫在线资源，一键收藏你喜欢的蜜桃系列，打造专属观影清单。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20beautifully%20organized%20collection%20display%2C%20various%20anime%20character%20portraits%20arranged%20artistically%2C%20soft%20peach%20and%20rose%20gold%20color%20palette%2C%20elegant%20gallery%20wall%20style%2C%20warm%20gallery%20lighting%2C%20sophisticated%20anime%20art%20presentation&width=800&height=560&seq=card-05-exclusive&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            五大精选蜜桃动漫在线专题，羞羞动漫在线观看从这里开始
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.slice(0, 3).map((card, i) => (
            <div
              key={i}
              className="group bg-background-100/60 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-3 py-1 bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:col-span-3">
            {cardsData.slice(3).map((card, i) => (
              <div
                key={i + 3}
                className="group bg-background-100/60 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-3 py-1 bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full">
                    {card.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}